import React from "react";
import CloseButton from "../CloseButton/CloseButton";

const backlogData = [
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "исключил из проекта",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "удалил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "ответил на комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
  {
    author: {
      name: "Александр Преображенский",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    action: "добавил комментарий",
    target: {
      name: "Эвелина Хромченко",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  },
];

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },
  modal: {
    width: "600px",
    backgroundColor: "#232733",
    borderRadius: "16px",
    padding: "36px 32px 24px 32px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxHeight: "80vh",
    overflow: "hidden",
  },
  title: {
    color: "#c1c4cb",
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 24,
    textAlign: "center",
  },
  list: {
    width: "100%",
    flex: 1,
    overflowY: "auto",
    marginTop: 0,
    paddingRight: 8,
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #31343c",
    fontSize: 14,
    color: "#c1c4cb",
    fontWeight: 500,
  },
  user: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    marginRight: 8,
    objectFit: "cover",
  },
  name: {
    color: "#c1c4cb",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 120,
  },
  action: {
    flex: 1,
    textAlign: "center",
    color: "#fff",
    fontWeight: 500,
    fontSize: 14,
  },
};

const hideScrollbar = {
  scrollbarWidth: "none",
  msOverflowStyle: "none",
};

const BacklogPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <CloseButton onClose={onClose} />
        <div style={modalStyles.title}>Бэклог</div>
        <div
          style={{ ...modalStyles.list, ...hideScrollbar }}
          className="backlog-list-no-scrollbar"
        >
          {backlogData.map((item, idx) => (
            <div key={idx} style={modalStyles.item}>
              <div style={modalStyles.user}>
                <img
                  src={item.author.avatar}
                  alt="avatar"
                  style={modalStyles.avatar}
                />
                <span style={modalStyles.name}>{item.author.name}</span>
              </div>
              <div style={modalStyles.action}>{item.action}</div>
              <div style={modalStyles.user}>
                <img
                  src={item.target.avatar}
                  alt="avatar"
                  style={modalStyles.avatar}
                />
                <span style={modalStyles.name}>{item.target.name}</span>
              </div>
            </div>
          ))}
        </div>
        <style>{`
          .backlog-list-no-scrollbar::-webkit-scrollbar { display: none; }
        `}</style>
      </div>
    </div>
  );
};

export default BacklogPopup;
